import React, { useRef, useState } from 'react';

const OTPInput = ({ length = 4, onComplete, disabled }) => {
  const inputRef = useRef(Array(length).fill(null));
  const [OTP, setOTP] = useState(Array(length).fill(''));

  const handleTextChange = (input, index) => {
    if (disabled) return; // Ignore input changes if disabled

    const newPin = [...OTP];
    newPin[index] = input;
    setOTP(newPin);

    if (input.length === 1 && index < length - 1) {
      inputRef.current[index + 1]?.focus();
    }

    if (input.length === 0 && index > 0) {
      inputRef.current[index - 1]?.focus();
    }

    if (newPin.every((digit) => digit !== '')) {
      onComplete(newPin.join(''));
    }
  };

  const handleInput = (event, index) => {
    const { value } = event.target;

    // Only allow digits
    if (/^\d*$/.test(value)) {
      handleTextChange(value, index);
    } else {
      event.target.value = ''; // Clear the input if non-digit is entered
    }
  };

  return (
    <div className="flex w-full justify-start" dir="ltr">
      {Array.from({ length }, (_, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          value={OTP[index]}
          autoFocus={index === 0}
          onInput={(e) => handleInput(e, index)}
          ref={(ref) => (inputRef.current[index] = ref)}
          className="rounded-lg h-24 py-2 mx-1 w-full px-3 text-customgreen focus:ring-2 focus:ring-customgreen focus:border-customgreen focus:outline-0 text-center border-gray-300"
          style={{ marginRight: index === length - 1 ? '0' : '10px', direction: 'rtl' }}
          disabled={disabled} // Apply disabled state
        />
      ))}
    </div>
  );
};

export default OTPInput;
